import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=2bdb9b60&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=2bdb9b60&prod&lang=less"
import style1 from "./Login.vue?vue&type=style&index=1&id=2bdb9b60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb9b60",
  null
  
)

export default component.exports